import React from "react";
import PropTypes from "prop-types";
import { Text } from "style/v2/components/Typography";
import { isLightColor, getTextColor } from "utils/color";
import { getTreemapFontSize } from "utils/treemap";
import {
  ContentContainer,
  TreemapContainer,
  TreemapRectangle,
  RectangleName,
  RectanglePercentage,
  TableContainer,
  TableHeader,
  TableRow,
  TableRowLeft,
  ColorIndicator,
  IndustryName,
  PercentageBadge,
} from "./StrategyTreemap.styles";

const IndustryView = ({
  rectangles,
  industries,
  containerWidth,
  containerHeight,
  isMobile,
}) => (
  <ContentContainer>
    <TreemapContainer>
      {rectangles.map((rect, i) => {
        const textColor = getTextColor(rect.color);
        const fontSize = getTreemapFontSize(rect.width, isMobile);
        return (
          <TreemapRectangle
            key={`${rect.name}-${i}`}
            $left={(rect.x / containerWidth) * 100}
            $top={(rect.y / containerHeight) * 100}
            $width={(rect.width / containerWidth) * 100}
            $height={(rect.height / containerHeight) * 100}
            $backgroundColor={rect.color}
            title={`${rect.name}: ${rect.percentage}`}
          >
            <RectangleName
              $fontSize={fontSize}
              $textColor={textColor}
              title={rect.name}
            >
              {rect.width < (isMobile ? 40 : 50)
                ? rect.name.split(" ")[0]
                : rect.name}
            </RectangleName>
            <RectanglePercentage
              $fontSize={fontSize}
              $textColor={textColor}
              title={rect.percentage}
            >
              {rect.percentage}
            </RectanglePercentage>
          </TreemapRectangle>
        );
      })}
    </TreemapContainer>

    <TableContainer>
      <TableHeader>
        <Text variant="bodyMedium" as="span">
          Industry
        </Text>
        <Text variant="bodyMedium" as="span">
          Percentage
        </Text>
      </TableHeader>
      {[...industries]
        .sort((a, b) => b.value - a.value)
        .map((ind, i) => (
          <TableRow key={`${ind.name}-${i}`}>
            <TableRowLeft>
              <ColorIndicator
                $color={ind.color}
                $needsBorder={isLightColor(ind.color)}
              />
              <IndustryName title={ind.name}>{ind.name}</IndustryName>
            </TableRowLeft>
            <PercentageBadge>{ind.percentage}</PercentageBadge>
          </TableRow>
        ))}
    </TableContainer>
  </ContentContainer>
);

IndustryView.propTypes = {
  rectangles: PropTypes.array.isRequired,
  industries: PropTypes.array.isRequired,
  containerWidth: PropTypes.number.isRequired,
  containerHeight: PropTypes.number.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default IndustryView;
